import { type Observable as ObservableType, Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import { Subject } from 'rxjs/Subject';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
// We import this directly because if we import it via index it'll create a circular dependency.
import { query$ } from '@atlassian/jira-software-swag/src/services/query/index.tsx';
import { setBacklogFetchStart, setBacklogFetchStop } from './backlog-data-metrics';
import { getQuery, backlogDataOperationName } from './query';
import type { PrefetchedDataGql, ResourcesCacheUpdateRequest } from './types';

const BACKLOG = 'BACKLOG' as const;

// Standard observer pattern, the middleware in board/backlog will invoke this
// when it comes across a matching redux mutation that requires the cache
// to be updated
const CacheUpdateSubject = new Subject<ResourcesCacheUpdateRequest>();

const loadAgilityGraphqlData = (
	baseUrl: string,
	boardId: string,
): ObservableType<PrefetchedDataGql> => {
	const requestStartTime = new Date().valueOf();
	const query = getQuery();

	setBacklogFetchStart();

	return query$<PrefetchedDataGql>(baseUrl, backlogDataOperationName, query, {
		boardId,
	}).flatMap((data: PrefetchedDataGql) => {
		const requestEndTime = new Date().valueOf();

		log.safeInfoWithoutCustomerData(`rest.swag.${backlogDataOperationName}.success`, '', {
			time: requestEndTime - requestStartTime,
		});

		// Everytime we fetch this data, we can use it to hydrate the BACKLOG resources-cache
		CacheUpdateSubject.next({ origin: BACKLOG, payload: data });

		setBacklogFetchStop();
		return Observable.of(data);
	});
};

export const fetchAgilityGraphqlData = (
	baseUrl: string,
	boardId: string,
): Promise<PrefetchedDataGql> =>
	loadAgilityGraphqlData(baseUrl, boardId)
		.toPromise()
		.then((response: PrefetchedDataGql) => response);

export default loadAgilityGraphqlData;
